import { useState, useEffect } from 'react';
import { CopyBlock } from "react-code-blocks";
import SelectedQuery from "../SelectedQuery";
import BlackScreen from "../BlackScreen";
import { queries } from "../../Data/Query";
import InterplayRocket from "../../assets/InterplayRocket";
import { codeBlockTheme } from "../../color";
import { CustomFlex } from '../Layout.elements';

const StaticCodeBlock = ({
  queryId,
  onQuesChange,
  onCrossButtonChange,
  setBlackScreen,
  setQueryIndex,
  setPageNumber,
  setQueryParams,
  setDynamicCodeSection
}) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const codeContainerStyle = {
    width: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    padding: '0',
    marginRight: '1.5rem',
    paddingBottom: '1rem',
    marginBottom: '7rem'
  };

  const query = queries.find((query) => query?.id === queryId);

  const handleQueryChange = (value) => {
    onQuesChange(value);
  };
  const handleCrossButton = (val) => {
    onCrossButtonChange(val);
  };
  return (
    <>
      <BlackScreen
        onQueryChanged={handleQueryChange}
        setBlackScreen={setBlackScreen}
        setQueryIndex={setQueryIndex}
        setPageNumber={setPageNumber}
        setDynamicCodeSection={setDynamicCodeSection}
      >
        <CustomFlex direction="column">
          <SelectedQuery
            isFirstQuery={true}
            question={query?.question}
            onCrossButtonChange={handleCrossButton}
            setBlackScreen={setBlackScreen}
            setQueryParams={setQueryParams}
          />
          <div className="message-container">
            <div className="chat-bot-svg">
              <InterplayRocket />
            </div>
            {query?.error ? (
              <div className="message-text">{query?.error}</div>
            ) : (
              <div className="response-content">
                {query && query?.content && (
                  <>
                    <p className="chat-response-text">
                      {query?.response?.content}
                    </p>
                    <br />
                  </>
                )}
                {query && query?.response?.code && (
                  <div className="code-container">
                    <CopyBlock
                      language={"python"}
                      text={`${query?.response?.code}`}
                      showLineNumbers={true}
                      theme={codeBlockTheme}
                      codeBlock
                      wrapLines
                      codeContainerStyle={codeContainerStyle}
                    />
                  </div>
                )}
              </div>
            )}            
        </div>
        </CustomFlex>
      </BlackScreen>
    </>
  );
};
export default StaticCodeBlock;
